import SequenceNumberListResourcePagingResultModel from '../../generated/types/model/resource/SequenceNumberListResourcePagingResultModel';

export default class SequenceNumberListResourcePagingResultViewModel extends SequenceNumberListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
